import agentDetailsQuery from '@queries/agentDetails.gql'

export default {
  getAuthAgentDetails: async (payload) => {
    const result = await payload.apollo.query({
      fetchPolicy: 'network-only',
      query: agentDetailsQuery,
      variables: {
        token: payload.token,
      },
    })
    return result.data.agent
  },
}
